import { useEffect, RefObject } from 'react'
import { useSetRecoilState } from 'recoil'
import { openModalState } from 'recoils/atoms'

type AnyEvent = MouseEvent | TouchEvent

function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: AnyEvent) => void,
): void {
  const setIsOpenModal = useSetRecoilState(openModalState)

  useEffect(() => {
    const listener = (event: AnyEvent) => {
      const el = ref?.current

      setIsOpenModal(false)
      if (!el || el.contains(event.target as Node)) {
        return
      }

      handler(event)
    }

    document.addEventListener(`mousedown`, listener)
    document.addEventListener(`touchstart`, listener)

    return () => {
      document.removeEventListener(`mousedown`, listener)
      document.removeEventListener(`touchstart`, listener)
    }
  }, [ref, handler])
}

export default useOnClickOutside
